import emiter from '@/utils/emiter'

export const LayoutEventHub = {
  EVENT_FULLSCREEN: '__POWER-GO-MAIN_EVENT-FULLSCREEN__',
  EVENT_COLLAPSE_STATUS: '__POWER-GO-MAIN_EVENT-COLLAPSE-STATUS__',

  isAsideCollapsed: false,
  isFullscreen: false,

  // 往 appSystemInfo 中新增参数
  addAppSystemInfo(extVal: Record<string, any>) {
    const curWin = window as any
    if (!curWin.appSystemInfo) curWin.appSystemInfo = {}
    curWin.appSystemInfo = { ...curWin.appSystemInfo, ...extVal }
  },

  requestFullscreen() {
    LayoutEventHub.isFullscreen = true
    emiter.emit(LayoutEventHub.EVENT_FULLSCREEN, true)
  },
  exitFullscreen() {
    LayoutEventHub.isFullscreen = false
    emiter.emit(LayoutEventHub.EVENT_FULLSCREEN, false)
  },
  toggleFullscreen(fullscreen?: boolean) {
    if (typeof fullscreen === 'boolean') {
      LayoutEventHub.isFullscreen = fullscreen
    } else {
      LayoutEventHub.isFullscreen = !LayoutEventHub.isFullscreen
    }
    emiter.emit(LayoutEventHub.EVENT_FULLSCREEN, LayoutEventHub.isFullscreen)
  },

  // 同步菜单展开收起状态的变更
  syncCollapseStatusChange(isCollapse: boolean) {
    LayoutEventHub.isAsideCollapsed = isCollapse
    emiter.emit(LayoutEventHub.EVENT_COLLAPSE_STATUS, isCollapse)
  },

  onFullscreenChange(callback: (payload: any) => void) {
    emiter.on(LayoutEventHub.EVENT_FULLSCREEN, callback)
  },

  onCollapseStatusChange(callback: (payload: any) => void) {
    emiter.on(LayoutEventHub.EVENT_COLLAPSE_STATUS, callback)
  }
}

// 对外使用的 sdk 集合
export const LayoutUtils = {
  requestFullscreen: LayoutEventHub.requestFullscreen,
  exitFullscreen: LayoutEventHub.exitFullscreen,
  toggleFullscreen: LayoutEventHub.toggleFullscreen,
  getFullscreenStatus: () => LayoutEventHub.isFullscreen
}
